import { useQuery } from '@tanstack/react-query';
import { useEffect, useLayoutEffect } from 'react';

import { publicMetadataOptions } from '@lib/api/options/public-metadata';
import {
  applyPageMetadata,
  applyPublicPageMetadata,
} from '@lib/utils/page-metadata';
import { isPublicMetadataPath } from '@lib/utils/public-metadata-path';

const PageMetadata = ({
  pathname,
  fallbackTitle,
}: {
  pathname: string;
  fallbackTitle?: string;
}) => {
  const supported = isPublicMetadataPath(pathname);
  const { data } = useQuery(publicMetadataOptions(pathname));

  useLayoutEffect(() => {
    // Reset route-owned fields immediately; never retain a previous entity image.
    // On initial load keep the complete server-injected metadata for this same path.
    const canonical = document.querySelector<HTMLLinkElement>(
      'link[rel="canonical"]',
    )?.href;

    const expectedPath =
      pathname.replace(/^\/lojas\//, '/').replace(/\/+$/, '') || '/';

    if (
      !supported ||
      !canonical ||
      new URL(canonical).pathname !== expectedPath
    ) {
      applyPageMetadata(fallbackTitle, pathname);
    }
  }, [pathname, fallbackTitle, supported]);

  useEffect(() => {
    if (data) {
      applyPublicPageMetadata(data);
    }
  }, [data, pathname]);
  return null;
};

export default PageMetadata;
